import { useEffect, useState } from "react";
import { faqList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqList.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.textContent = JSON.stringify(schema);
    document.head.appendChild(s);
    return () => {
      document.head.removeChild(s);
    };
  }, []);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading eyebrow="常见问题" title="关于吃瓜17，你可能想问" sub="对热度排行、内容来源与投稿规则有任何疑问，这里集中解答。若仍不清楚，也欢迎通过底部表单与我们联系。" />
            <div className="mt-6 rounded-xl bg-accent-100/80 p-5">
              <p className="flex items-center gap-2 text-sm font-bold text-accent-900"><i className="ri-shield-check-line"></i>内容原则</p>
              <p className="mt-2 text-sm leading-relaxed text-accent-800/90">不造谣不传谣，只聚合公开信息；理性围观，把结论交给时间与官方核实。</p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              {faqList.map((f, i) => {
                const isOpen = openIdx === i;
                return (
                  <div key={f.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(isOpen ? null : i)}
                      className="flex w-full items-center gap-3 px-5 py-4 text-left md:px-6"
                      aria-expanded={isOpen}
                    >
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs font-bold ${isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"}`}>
                        Q{i + 1}
                      </span>
                      <span className="flex-1 text-[15px] font-semibold text-foreground-950">{f.q}</span>
                      <i className={`text-lg text-primary-600 transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}></i>
                    </button>
                    <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-96 pb-5" : "max-h-0"}`}>
                      <p className="px-5 pl-[4.25rem] text-sm leading-relaxed text-foreground-700 md:px-6 md:pl-[4.5rem]">{f.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}